import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Spinner,
  Tabs,
  Tab,
} from "react-bootstrap";
import { useForm, useFieldArray } from "react-hook-form";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import "./config.css";

const WebConfigSetting = () => {
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "membership_contact",
  });

  const [loader, setLoader] = useState(false);
  const [activeTab, setActiveTab] = useState("general");

  useEffect(() => {
    getSettingListing();
  }, []);

  const getSettingListing = () => {
    WebService.getAPI({ action: `web-setting/details` })
      .then((res: any) => {
        const data = res.data || {};
        reset(data);

        // 👇 important for array/object
        setValue("membership_contact", data.membership_contact || []);
        setValue("get_in_touch", data.get_in_touch || {});
      })
      .catch(() => { });
  };

  const onSave = (data: any) => {
    setLoader(true);
    WebService.putAPI({
      action: `web-setting/update`,
      body: data,
    })
      .then((res: any) => {
        toast.success(res.message || "Settings updated");
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
        toast.error("Failed to update settings");
      });
  };

  return (
    <div className="events-main">
      <Card className="event-card p-4">
        <h4 className="mb-3">Web Config Setting</h4>

        <Form onSubmit={handleSubmit(onSave)}>
          <Tabs
            activeKey={activeTab}
            onSelect={(k: any) => setActiveTab(k)}
            className="mb-4"
          >
            {/* ================= GENERAL TAB ================= */}
            <Tab eventKey="general" title="General">
              <Row className="mb-2">
                <Col md={12} className="mb-3">
                  <Form.Label>Admin Email</Form.Label>
                  <Form.Control {...register("admin_email", {
                    required: false,
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  })} />
                  {errors.admin_email && (
                    <div className="error-message">
                      {errors.admin_email?.message?.toString()}
                    </div>
                  )}
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Label>Support Email</Form.Label>
                  <Form.Control {...register("support_email", {
                    required: false,
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  })} />
                  {errors.support_email && (
                    <div className="error-message">
                      {errors.support_email?.message?.toString()}
                    </div>
                  )}
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control {...register("company_name")} />
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control {...register("address")} />
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Label>Twitter URL</Form.Label>
                  <Form.Control {...register("twitter_url")} />
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Label>Facebook URL</Form.Label>
                  <Form.Control {...register("facebook_url")} />
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Label>LinkedIn URL</Form.Label>
                  <Form.Control {...register("linkedin_url")} />
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Label>YouTube URL</Form.Label>
                  <Form.Control {...register("youtube_url")} />
                </Col>
              </Row>
            </Tab>

            {/* ================= MEMBERSHIP CONTACT TAB ================= */}
            <Tab eventKey="membership" title="Membership Contact">
              {fields.map((item, index) => (
                <Card key={item.id} className="p-3 mb-3 border">
                  <Row>
                    <Col md={6}>
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        {...register(`membership_contact.${index}.name`)}
                      />
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Label>Position</Form.Label>
                      <Form.Control
                        {...register(`membership_contact.${index}.position`)}
                      />
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Label>Company</Form.Label>
                      <Form.Control
                        {...register(`membership_contact.${index}.company`)}
                      />
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        {...register(`membership_contact.${index}.email`, {
                          required: "Email is required",
                          pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "Please enter a valid email address",
                          },
                        })}
                      />
                      {(errors.membership_contact as any)?.[index]?.email && (
                        <div className="error-message">
                          {(errors.membership_contact as any)[index].email.message}
                        </div>
                      )}
                    </Col>

                    <Col md={6} className="mb-3">
                      <Form.Label>Mobile</Form.Label>
                      <Form.Control
                        maxLength={10}
                        {...register(`membership_contact.${index}.mobile`)}
                      />
                    </Col>

                    <Col md={12} className="text-end mt-2">
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => remove(index)}
                      >
                        Remove
                      </Button>
                    </Col>
                  </Row>
                </Card>
              ))}

              {/* <Button
                variant="secondary"
                size="sm"
                onClick={() =>
                  append({
                    name: "",
                    position: "",
                    company: "",
                    email: "",
                    mobile: "",
                  })
                }
              >
                + Add Contact
              </Button> */}
            </Tab>

            {/* ================= GET IN TOUCH TAB ================= */}
            <Tab eventKey="getintouch" title="Get In Touch">
              <Row>
                <Col md={12} className="mb-3">
                  <Form.Label>Address</Form.Label>
                  <Form.Control {...register("get_in_touch.address")}  as="textarea" rows={3} />
                  
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Label>Email 1</Form.Label>
                  <Form.Control {...register("get_in_touch.email1", {
                    required: false,
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  })} />
                  {(errors.get_in_touch as any)?.email1 && (
                    <div className="error-message">
                      {(errors.get_in_touch as any).email1.message?.toString()}
                    </div>
                  )}
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Label>Email 2</Form.Label>
                  <Form.Control {...register("get_in_touch.email2", {
                    required: false,
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  })} />
                  {(errors.get_in_touch as any)?.email2 && (
                    <div className="error-message">
                      {(errors.get_in_touch as any)?.email2.message?.toString()}
                    </div>
                  )}
                </Col>

                <Col md={12} className="mb-3">
                  <Form.Label>Mobile</Form.Label>
                  <Form.Control {...register("get_in_touch.mobile")} />
                </Col>
              </Row>
            </Tab>
          </Tabs>

          {/* SAVE BUTTON */}
          <div className="text-center mt-4">
            <Button type="submit" variant="primary" style={{ width: 180 }}>
              {loader && <Spinner size="sm" className="me-2" />}
              Save
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default WebConfigSetting;
